<script setup>
import AppMenu from './AppMenu.vue';
import { useLayout } from '@/layout/composables/layout';
import { onMounted } from 'vue';
import { useStates } from '../router/states';
import CompanySelector from './CompanySelector.vue';

const { layoutState, layoutConfig, replaceLink } = useLayout();
const { userState } = useStates();

let timeout = null;

const onMouseEnter = () => {
  if (!layoutState.anchored.value) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    layoutState.sidebarActive.value = true;
  }
};

const onMouseLeave = () => {
  if (!layoutState.anchored.value) {
    if (!timeout) {
      timeout = setTimeout(() => (layoutState.sidebarActive.value = false), 300);
    }
  }
};

const anchor = () => {
  layoutState.anchored.value = !layoutState.anchored.value;
};

onMounted(async () => {
  const themeLink = document.getElementById('theme-link');
  const themeHref = themeLink.getAttribute('href');
  const newHref = themeHref.replace(layoutConfig.componentTheme.value, 'green');

  if (replaceLink) {
    replaceLink(themeLink, newHref, () => {
      layoutConfig.componentTheme.value = 'green';
    });
  }
});
</script>

<template>
  <div class="layout-sidebar" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <div class="layout-sidebar-top">
      <CompanySelector v-if="userState?.data?.value?.email"></CompanySelector>
      <button class="layout-sidebar-anchor p-link" type="button" @click="anchor()"></button>
    </div>
    <div class="layout-menu-container">
      <AppMenu />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout-sidebar-logo,
.layout-sidebar-logo-slim {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
